import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

const useHistoryListener = (onAction?: (location, action) => void) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    let nav: any = navigator;

    return nav.listen(({ action, location }) => {
      onAction?.(location, action);
    });
  }, []);
};

export default useHistoryListener;
